// Utility functions for Arabic numerals conversion

/**
 * Convert Western numerals (0123456789) to Arabic-Indic numerals (٠١٢٣٤٥٦٧٨٩)
 */
export const toArabicNumerals = (str) => {
  if (str === null || str === undefined) return str;
  
  const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
  
  return str.toString().replace(/[0-9]/g, (digit) => {
    return arabicNumerals[parseInt(digit)];
  });
};

/**
 * Format number with Arabic numerals and thousands separators
 */
export const formatArabicNumber = (number) => {
  if (number === null || number === undefined) return '';
  
  // Format with thousands separators
  const formatted = number.toLocaleString('ar-SA');
  
  // Convert to Arabic numerals
  return toArabicNumerals(formatted);
};

/**
 * Format currency in Arabic
 */
export const formatArabicCurrency = (amount, currency = 'ريال') => {
  if (amount === null || amount === undefined) return '';
  
  const formattedAmount = formatArabicNumber(amount);
  return `${formattedAmount} ${currency}`;
};

/**
 * Format time in Arabic
 */
export const formatArabicTime = (timestamp) => {
  const date = new Date(timestamp);
  const timeString = date.toLocaleTimeString('ar-SA', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  
  return toArabicNumerals(timeString);
};